import React, { useEffect, useRef } from 'react'
import styles from './IdCardForm.module.scss'

function csrfToken() {
  const el = document.querySelector('meta[name="csrf-token"]')
  return el ? el.getAttribute('content') : ''
}

export function CsvImportButton({ templateId, csvJob, setCsvJob }) {
  const inputRef = useRef(null)
  const busy = csvJob && ['queued', 'processing'].includes(csvJob.status)

  async function handleFileChange(e) {
    const file = e.target.files && e.target.files[0]
    e.target.value = ''
    if (!file) return

    const formData = new FormData()
    formData.append('csv', file)

    setCsvJob({ status: 'queued', total: 0, processed: 0 })

    try {
      const res = await fetch(`/new_templates/${templateId}/import_csv`, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrfToken() },
        body: formData,
      })
      const data = await res.json()
      if (!res.ok) {
        setCsvJob({ status: 'error', error: data.error || 'Upload failed' })
        return
      }
      setCsvJob({ jobId: data.job_id, status: 'queued', total: data.total, processed: 0 })
    } catch (err) {
      setCsvJob({ status: 'error', error: err.message })
    }
  }

  return (
    <>
      <input
        type="file"
        accept=".csv,text/csv"
        ref={inputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        className={styles.pdfButton}
        disabled={busy}
        style={{ background: busy ? '#888' : '#5cb85c', border: 'none', cursor: busy ? 'default' : 'pointer' }}
        onClick={() => inputRef.current && inputRef.current.click()}
      >
        {busy ? 'Importing…' : 'Import CSV'}
      </button>
    </>
  )
}

export function CsvImportStatus({ templateId, csvJob, setCsvJob, onDismiss }) {
  const jobId = csvJob.jobId
  const isActive = ['queued', 'processing'].includes(csvJob.status)

  useEffect(() => {
    if (!jobId || !isActive) return

    let cancelled = false
    const tick = async () => {
      try {
        const res = await fetch(`/new_templates/${templateId}/csv_export_status?job_id=${jobId}`)
        if (!res.ok) return
        const data = await res.json()
        if (cancelled) return
        setCsvJob({
          jobId,
          status: data.status,
          total: data.total,
          processed: data.processed,
          pdfUrl: data.pdf_url,
          error: data.error,
        })
      } catch (_) {}
    }
    const interval = setInterval(tick, 2000)
    return () => { cancelled = true; clearInterval(interval) }
  }, [jobId, isActive, templateId])

  const percent = csvJob.total > 0 ? Math.round((csvJob.processed / csvJob.total) * 100) : 0

  return (
    <div style={{
      marginTop: 10, padding: '10px 14px', borderRadius: 5,
      background: '#f7f7f9', border: '1px solid #ddd', fontSize: 14
    }}>
      {csvJob.status === 'queued' && <span>Queued — waiting for worker…</span>}
      {csvJob.status === 'processing' && (
        <span>Generating PDF: {csvJob.processed} of {csvJob.total} ({percent}%)</span>
      )}
      {csvJob.status === 'complete' && (
        <>
          <span style={{ color: '#2a7a2a', marginRight: 12 }}>✓ Complete ({csvJob.total} rows)</span>
          <a href={csvJob.pdfUrl} target="_blank" rel="noopener noreferrer"
             style={{ color: '#337ab7', textDecoration: 'underline' }}>
            Download PDF
          </a>
          <button onClick={onDismiss} style={{ marginLeft: 10, background: 'transparent', border: 'none', color: '#888', cursor: 'pointer' }}>✕</button>
        </>
      )}
      {csvJob.status === 'error' && (
        <>
          <span style={{ color: '#c33' }}>Error: {csvJob.error}</span>
          <button onClick={onDismiss} style={{ marginLeft: 10, background: 'transparent', border: 'none', color: '#888', cursor: 'pointer' }}>✕</button>
        </>
      )}
    </div>
  )
}
